export interface Propriedade {
  idFazenda: string
  documento: string | null
  endereco: string | null
  cidade: string | null
}

export interface UserParams {
  id: string
  idFazenda: string
  acao?: string
  confirmado?: string
  dataCriacao?: string
  dataUltimoSync?: string | null
  documento?: string | null
  emailConfirmado?: string | null
  identificacao?: string | null
  key?: string | null
  listPropriedades?: any[]
  melhoramentoGenetico?: any | null
  nome?: string
  perfil?: string | null
  senhaResetada?: string | null
  senha?: string | null
  sobrenome?: string | null
  telefone?: string | null
  telefoneConfirmado?: string | null
  username?: string
  usernameUpperCase?: string | null
  versaoAtual?: string | null
}

export class User {
  acao?: string
  confirmado?: string
  dataCriacao?: string
  dataUltimoSync?: string | null
  documento?: string | null
  emailConfirmado?: string | null
  id: string
  idFazenda: string
  identificacao?: string | null
  key?: string | null
  listPropriedades?: Propriedade[]
  melhoramentoGenetico?: string | null
  nome?: string
  perfil?: string | null
  senha?: string | null
  senhaResetada?: string | null
  sobrenome?: string | null
  telefone?: string | null
  telefoneConfirmado?: string | null
  username?: string
  usernameUpperCase?: string | null
  versaoAtual?: string | null

  constructor({
    acao,
    confirmado,
    dataCriacao = new Date().toISOString(),
    dataUltimoSync = null,
    documento = null,
    emailConfirmado = null,
    id,
    idFazenda,
    identificacao = null,
    key = null,
    listPropriedades = [],
    melhoramentoGenetico = null,
    nome,
    perfil,
    senha = null,
    senhaResetada = '',
    sobrenome = null,
    telefone,
    telefoneConfirmado = '',
    username,
    usernameUpperCase = '',
    versaoAtual = ''
  }: UserParams) {
    this.acao = acao
    this.confirmado = confirmado
    this.dataCriacao = dataCriacao
    this.dataUltimoSync = dataUltimoSync
    this.documento = documento
    this.emailConfirmado = emailConfirmado
    this.id = id
    this.idFazenda = idFazenda
    this.identificacao = identificacao
    this.key = key
    this.listPropriedades = listPropriedades
    this.melhoramentoGenetico = melhoramentoGenetico
    this.nome = nome
    this.perfil = perfil
    this.senha = senha
    this.senhaResetada = senhaResetada
    this.sobrenome = sobrenome
    this.telefone = telefone
    this.telefoneConfirmado = telefoneConfirmado
    this.username = username
    this.usernameUpperCase = usernameUpperCase
    this.versaoAtual = versaoAtual
  }
}
